import React from 'react';
import TpAdminService from '../../../../Services/TpAdminService';
import ErrorMessage from '../../../ErrorMessage';
import SelectFieldCheckbox from './SelectFieldCheckbox';

export default class FreelancerUserManagerSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    multipleIdFilter: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.multipleIdFilter) != JSON.stringify(this.props.multipleIdFilter)) {
      this.populateListData();
    }
  }

  populateListData() {
    TpAdminService.GetTpAdminForFreelancerUser(this.props.multipleIdFilter)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((admin) => {
          optValues.push({
            label: admin.displayName,
            value: admin.tpAdminId,
            disabled: false,
          });
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('FUMS46');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
        showSelectFilterAt={this.props.showSelectFilterAt}
      />
    );
  }
}
